import useLenis from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import ProductMarquee from "@/components/site/ProductMarquee";
import PhraseMarquee from "@/components/site/PhraseMarquee";
import PartnerBand from "@/components/site/PartnerBand";
import ValveShowcase from "@/components/site/ValveShowcase";
import HowItWorks from "@/components/site/HowItWorks";
import Features from "@/components/site/Features";
import Pricing from "@/components/site/Pricing";
import WhoWeAre from "@/components/site/WhoWeAre";
import BookingPortal from "@/components/site/BookingPortal";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <main className="relative bg-[#050505] text-white antialiased">
      <Header />
      <Hero />
      <PartnerBand />
      <PhraseMarquee speed={30} />
      <ValveShowcase />
      <HowItWorks />
      <Features />
      <Pricing />
      <WhoWeAre />
      <BookingPortal />
      <ProductMarquee text="LEAK SMART SHIELD" sep="GREATER PROTECTION" speed={22} />
      <LeadForm />
      <Footer />
    </main>
  );
}
